<template>
  <div>
    <ul v-if="systemsList">
      <li @click="selectItem(system)" v-for="system in systemsList" :key="system.iconFile">
        <img width="70px" :src="`systems_icons/${system.iconFile}` | s3Image" alt="">
        {{ system.name }}
      </li>
    </ul>
  </div>
</template>

<script>

import {mapState, mapActions} from 'vuex'

export default {
  name: 'SystemsList',
  // props: ['onSelect'],
  data() {
    return {
    }
  },
  methods: {
    selectItem(system) {
      this.$emit('onSelect', system)
    }
  },
  computed: {
    ...mapState('appliancesStore', ['systemsList'])
  },
  mounted() {
    //console.log(this.systemsList)
    }
}
</script>

<style lang="sass">
  .systems-list-wrap
    position: relative

  .systems-list
    position: absolute
    background-color: white
    width: auto
    top: 60px
    border: 1px solid #b9b9b9
    overflow-y: scroll
    max-height: 250px
    z-index: 100
    // height: 200px

    ul
      list-style: none
      padding: 0
      margin: 0
    //   display: flex
    //
    li
      padding: 5px
      display: block
      cursor: pointer

      &:hover
        background-color: #e2e2e2
    //   width: 40px
    //   height: 40px
    //   display: block
    //   background-color: blue
</style>



// WEBPACK FOOTER //
// SystemsList.vue?8d601c86